import React from "react";

export const MessengerContext = React.createContext({
  templates: [],
  setTemplates: (e) => {},
  templateId: null,
  setTemplateId: (e) => {},
  template: null,
  setTemplate: (e) => {},
  recipientFilter: null,
  setRecipientFilter: (e) => {},
  recipients: [],
  setRecipients: (e) => {},
  canSend: false,
  sendAt: null,
  setSendAt: (e) => {},
  channel: null,
  setChannel: (e) => {}
});
